export default "ORI - Gestão de Templos de Umbanda";
